"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// We are duplicating markup to have a more maintainable codebase, instead of a smarter CSS selector
// (see https://gitlab.skypicker.com/frontend/core/-/merge_requests/1565/diffs?commit_id=f318a34d66422c58317bdc5d08c00fd4c530d843 for an example).
//
// We only want to render the icon on mobile, but putting the logic around the icon doesn't work because
// of some spacing issues with the ButtonLink component which has specific markup, etc.
//
// Discussion: https://gitlab.skypicker.com/frontend/core/-/merge_requests/1565#note_4254329
const Link = _ref => {
  let {
    active,
    link,
    icon,
    children,
    rel,
    external
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "de:hidden",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
        iconLeft: icon,
        compact: true,
        type: active ? "primary" : "secondary",
        href: link,
        external: external,
        rel: rel,
        children: children
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "hidden de:block",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
        compact: true,
        type: active ? "primary" : "secondary",
        href: link,
        external: external,
        rel: rel,
        children: children
      })
    })]
  });
};
var _default = exports.default = Link;